import type { SlideImage } from "yet-another-react-lightbox";
export function Gallery2015(){


const slides: SlideImage[] = [
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_001.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_001.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_002.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_002.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_003.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_003.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_004.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_004.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_005.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_005.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_006.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_006.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_007.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_007.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_008.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_008.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_009.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_009.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_010.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_010.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_011.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_011.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_012.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_012.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_013.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_013.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_014.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_014.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_015.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_015.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_016.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_016.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_017.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_017.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_018.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_018.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_019.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_019.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_020.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_020.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_021.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_021.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_022.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_022.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_023.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_023.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_024.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_024.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_025.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_025.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_026.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_026.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_027.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_027.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_028.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_028.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_029.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_029.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_030.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_030.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_031.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_031.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_032.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_032.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_033.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_033.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_034.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_034.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_035.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_035.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_036.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_036.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_037.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_037.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_038.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_038.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_039.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_039.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_040.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_040.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_041.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_041.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_042.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_042.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_043.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_043.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_044.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_044.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_045.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_045.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_046.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_046.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_047.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_047.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_048.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_048.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_049.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_049.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_050.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_050.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_051.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_051.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_052.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_052.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_053.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_053.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_054.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_054.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_055.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_055.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_056.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_056.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_057.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_057.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_058.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_058.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_059.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_059.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_060.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_060.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_061.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_061.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_062.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_062.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_063.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_063.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_064.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_064.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_065.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_065.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_066.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_066.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_067.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_067.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_068.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_068.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_069.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_069.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_070.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_070.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_071.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_071.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_072.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_072.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_073.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_073.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_074.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_074.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_075.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_075.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_076.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_076.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_077.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_077.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_078.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_078.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_079.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_079.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_080.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_080.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_081.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_081.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_082.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_082.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_083.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_083.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_084.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_084.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_085.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_085.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_086.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_086.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_087.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_087.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_088.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_088.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_089.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_089.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_090.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_090.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_091.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_091.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_092.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_092.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_093.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_093.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_094.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_094.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_095.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_095.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_096.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_096.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_097.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_097.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_098.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_098.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_099.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_099.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_100.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_100.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_101.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_101.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_102.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_102.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_103.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_103.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_104.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_104.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_105.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_105.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_106.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_106.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_107.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_107.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_108.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_108.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_109.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_109.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_110.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_110.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_111.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_111.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_112.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_112.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_113.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_113.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_114.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_114.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_115.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_115.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_116.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_116.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_117.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_117.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_118.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_118.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_119.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_119.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_120.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_120.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_121.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_121.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_122.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_122.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_123.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_123.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_124.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_124.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_125.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_125.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_126.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_126.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_127.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_127.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_128.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_128.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_129.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_129.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_130.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_130.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_131.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_131.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_132.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_132.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_133.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_133.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_134.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_134.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_135.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_135.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_136.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_136.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_137.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_137.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_138.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_138.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_139.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_139.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_140.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_140.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_141.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_141.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_142.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_142.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_143.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_143.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_144.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_144.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_145.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_145.jpg"
      },
      {
        "src":  "https://jamhaw.com/images/gallery/Gallery2015/IMG_146.jpg",
        "alt":  "https://jamhaw.com/images/gallery/Gallery2015/SML_146.jpg"
      }
      ];

     return slides;
} 
